/**
 * Base API URL for the current environment.
 * Uses .env: VITE_DEV_API_URL, VITE_STAGING_API_URL, VITE_PROD_API_URL.
 * - npm run dev (development): VITE_DEV_API_URL
 * - Staging: VITE_STAGING_API_URL (same as prod)
 * - Production: VITE_PROD_API_URL
 * VITE_LOCAL_API_URL is for local server.mjs only (not used by getApiBaseUrl).
 */
export function getApiBaseUrl() {
  const mode = import.meta.env.MODE;
  if (mode === 'production') {
    return import.meta.env.VITE_PROD_API_URL || '';
  }
  if (mode === 'staging') {
    return import.meta.env.VITE_STAGING_API_URL || import.meta.env.VITE_PROD_API_URL || '';
  }
  // development (npm run dev): use remote dev server
  return import.meta.env.VITE_DEV_API_URL || '';
}
